import React from "react";
import { MdAssignment, MdBarChart, MdListAlt } from "react-icons/md";
import Button from "components/button";

const HIGHLIGHTS = [
  {
    icon: MdAssignment,
    title: "25 Questions",
    description: "A focused set of questions designed to reveal your unique ministry profile.",
  },
  {
    icon: MdListAlt,
    title: "Mixed Format",
    description: "Multiple choice and rating scale questions for a well-rounded assessment.",
  },
  {
    icon: MdBarChart,
    title: "See Your Results",
    description: "Instantly discover your primary archetype and personalized insights.",
  },
];

const AssessmentIntro = ({ organizationName, onBegin }) => (
  <>
    <div className="text-center">
      <h1 className="text-title">
        {organizationName ? `Welcome from ${organizationName}` : "Welcome to Your Assessment"}
      </h1>
      <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-fg-muted">
        Discover how you are uniquely wired to serve, lead, and grow within your community.
      </p>
    </div>

    <ul className="my-8 divide-y divide-line/60">
      {HIGHLIGHTS.map(({ icon: Icon, title, description }) => (
        <li key={title} className="flex items-start gap-4 py-4 first:pt-0 last:pb-0">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-control bg-brand-100 text-brand-700 dark:bg-brand-900/40 dark:text-brand-200">
            <Icon aria-hidden="true" className="h-5 w-5" />
          </span>
          <div>
            <h2 className="text-sm font-semibold text-fg">{title}</h2>
            <p className="mt-0.5 text-sm leading-relaxed text-fg-muted">{description}</p>
          </div>
        </li>
      ))}
    </ul>

    <Button size="lg" fullWidth onClick={onBegin}>
      Begin Assessment
    </Button>
  </>
);

export default AssessmentIntro;
